<template>
    <div :class="['plan-item', { active: selected, 'single-product': singleProduct }]">
        <div v-if="singleProduct" :class="{'plan-disabled': itemDisabled(eplan)}">
            <div class="plan-name" @click.prevent="selectProduct(eplan)">
                <reo-radio class="plan-name-checked" v-model="mySelectedId" :type="itemDisabled(eplan) ? 'original' : 'highlight'" :label="eplan.id" :disabled="itemDisabled(eplan)">
                    <span class="plan-name-text">
                        {{ eplan.title }}
                        <template v-if="eplan.title !== config.beta_plan_title">
                            ({{ $tc( `cycle.${eplan.cycle.standard.interval.unit}`, eplan.cycle.standard.interval.frequency, {
                                count: eplan.cycle.standard.interval.frequency
                            } ) }})
                        </template>
                        <template v-else>
                            ({{ $tc( 'plan.stock', eplan.stockQuantity, {count: $n(eplan.stockQuantity, 'decimal')} ) }})
                        </template>
                        <span class="price-box">
                            <span v-if="Number(eplan.cycle.standard.salePrice) < Number(eplan.cycle.standard.regularPrice)" class="pre-price">{{$t(`CURRENCY.${eplan.currency}`)}} {{eplan.cycle.standard.regularPrice}}</span><span class="red title-price">{{ price }}</span>
                        </span>
                    </span>
                </reo-radio>
                <span v-if="eplan.id === currentPlan" class="current-plan pc">{{ $t('current_plan') }}</span>
                <span v-if="eplan.id === currentPlan" class="current-plan mobile">{{ $t('current_plan_abbr') }}</span>
            </div>
            <p>
                <span v-html="$options.filters.planHistory(eplan)"></span>{{ $t('comma') }}
                <span v-html="$options.filters.planCamera(eplan)"></span>{{ $t('comma') }}
                <span v-if="!FEATURE('dashboard.used_space')" v-html="$options.filters.planCapacity(eplan)"></span>
                <span v-if="showBeta(eplan)">{{ $t('comma') }}
                    <span v-html="$t('plan.beta_notice')"></span>
                </span>
                <span v-else-if="eplan.title === config.beta_plan_title">.
                    {{ $t('plan.limited_day', limitedDay) }}
                </span>
            </p>
        </div>
        <div v-else :class="{'plan-disabled': seriesDisabled}">
            <div class="plan-name" @click="active = !active">
                <checkbox v-model="selected" class="plan-name-checked" :type="seriesDisabled ? 'original' : 'highlight'" :disabled="checkboxDisabled"></checkbox>
                <span class="plan-name-text">{{ eplan.title }}<span class="red title-price">{{ price }}</span></span>
            </div>
            <p>
                <span v-html="$t('plan.maxHistory', {
                    history: Math.max(...arrangePlansParams[0])
                })"></span>;
                <span v-html="$tc('plan.maxCamera', Math.max(...arrangePlansParams[1]), {
                    count: Math.max(...arrangePlansParams[1])
                })"></span>;
                <span v-if="!FEATURE('dashboard.used_space')" v-html="$t('plan.maxStorage', {
                    storage: $n( Math.max(...arrangePlansParams[2]) )
                })"></span><template v-if="showBeta(eplan)">; <span v-html="$t('plan.beta_notice')"></span></template>
            </p>
            <div :class="['plan-series', activeFirstly ? '' : 'no-active']" ref="series">
                <template v-if="!needArrange">
                    <p v-for="(product, index) in plan.products" :key="index" @click.prevent="selectProduct(product)" :class="['series-item', {'plan-disabled': itemDisabled(product)}]">
                        <reo-radio v-model="mySelectedId" :type="itemDisabled(product) ? 'original' : 'highlight'" :label="product.id" :disabled="checkboxDisabled"></reo-radio>
                        <span class="plan-details">
                            <span>{{ $tc( `cycle_count.${product.cycle.standard.interval.unit}`, product.cycle.standard.interval.frequency, {

                                count: product.cycle.standard.interval.frequency

                            }) }} {{ $t('plan_item_subscription') }}</span>
                            <span class="price-box">
                                <span class="pre-price" v-if="Number(product.cycle.standard.salePrice) < Number(product.cycle.standard.regularPrice)">{{$t(`CURRENCY.${product.currency}`)}} {{product.cycle.standard.regularPrice}}</span><span class="price">{{$t(`CURRENCY.${product.currency}`)}} {{product.cycle.standard.salePrice}}</span>
                            </span>
                            <span v-if="product.id === currentPlan" class="current-plan pc">
                                {{ $t('current_plan') }}
                            </span>
                            <span v-if="product.id === currentPlan" class="current-plan mobile">
                                {{ $t('current_plan_abbr') }}
                            </span>
                        </span>
                        <span class="plan-description">{{ product.description }}</span>
                    </p>
                </template>
                <template v-if="needArrange">
                    <div v-for="(item, index) in arrangePlansMap" :key="index" class="device-quantity-box">
                        <span class="device-quantity-title" v-html="$t('plan.history', { history: item[0][0] })"></span>{{ $t('comma') }}
                        <span class="device-quantity-title" v-html="$tc('plan.camera', item[0][1], { count: item[0][1] })"></span>{{ !FEATURE('dashboard.used_space') ? $t('comma') : '' }}
                        <span v-if="!FEATURE('dashboard.used_space')" class="device-quantity-title" v-html="$t('plan.storage', {storage: $n( item[0][2] )})"></span>
                        <p v-for="(product, index) in item[1]" :key="index" @click.prevent="selectProduct(product)" :class="['series-item', {'plan-disabled': itemDisabled(product)}]">
                            <reo-radio v-model="mySelectedId" :type="itemDisabled(product) ? 'original' : 'highlight'" :label="product.id" :disabled="checkboxDisabled"></reo-radio>
                            <span class="plan-details">
                                <span>{{ $tc( `cycle_count.${product.cycle.standard.interval.unit}`, product.cycle.standard.interval.frequency, {

                                    count: product.cycle.standard.interval.frequency

                                }) }} {{ $t('plan_item_subscription') }}</span>
                                <span class="price-box">
                                    <span class="pre-price" v-if="Number(product.cycle.standard.salePrice) < Number(product.cycle.standard.regularPrice)">{{$t(`CURRENCY.${product.currency}`)}} {{product.cycle.standard.regularPrice}}</span><span class="price">{{$t(`CURRENCY.${product.currency}`)}} {{product.cycle.standard.salePrice}}</span>
                                </span>
                                <span v-if="product.id === currentPlan" class="current-plan pc">
                                    {{ $t('current_plan') }}
                                </span>
                                <span v-if="product.id === currentPlan" class="current-plan mobile">
                                    {{ $t('current_plan_abbr') }}
                                </span>
                            </span>
                            <span class="plan-description">{{ product.description }}</span>
                        </p>
                    </div>
                </template>
            </div>
            <span :class="['switchs', {disabled: seriesDisabled}]" @click="active = !active">
                {{ switchs }}
            </span>
            <div v-show="!active" class="switchs-cover" @click="active = true"></div>
        </div>
    </div>
</template>

<script>
import { timeResolvePDT } from '@/common/js/date';
import Checkbox from '@/basic/Checkbox';
import reoRadio from '@/basic/Radio';
import {config} from 'CONFIG';

export default {

    components: {

        Checkbox,
        reoRadio

    },

    props: {

        plan: Object,
        selectedId: Number,
        currentPlan: {

            type: Number,
            default () {

                return 0;

            }

        },
        disabledPlan: {

            type: Array,
            default () {

                return [];

            }

        },
        index: Number,
        activeItem: Number

    },

    data () {

        let eplan = this.plan.products[0];
        let active = false;
        let activeFirstly = false;
        if ( eplan.metadata[ 'plan.recommended' ] === 1 ) {

            active = true;
            activeFirstly = true;

        }
        return {

            eplan,
            mySelectedId: this.selectedId,
            active,
            activeFirstly,
            checkboxDisabled: true,
            config

        };

    },
    methods: {

        selectProduct ( plan ) {

            if ( !this.itemDisabled( plan )) {

                this.$emit( 'selectProduct', plan );

            }

        },
        itemDisabled ( product ) {

            return this.disabledPlan.includes( product.id );

        },
        showBeta ( plan ) {

            return this.$store.state.user.showBeta && plan.title !== config.beta_plan_title;

        }

    },
    computed: {
        arrangePlansParams () {

            let deviceHistorys = new Set();
            let deviceQuantitys = new Set();
            let deviceStorages = new Set();

            this.plan.products.forEach(( product ) => {

                deviceHistorys.add( product.metadata['cloud_storage.video_lifetime'] );
                deviceQuantitys.add( product.metadata['cloud_storage.max_device_quantity'] );
                deviceStorages.add( Number( product.metadata[ 'cloud_storage.space_capacity' ] / ( 1024 * 1024 * 1024 ).toFixed( 2 )));

            });

            return [
                Array.from( deviceHistorys ).sort(( a, b ) => a - b ),
                Array.from( deviceQuantitys ).sort(( a, b ) => a - b ),
                Array.from( deviceStorages ).sort(( a, b ) => a - b )
            ];

        },
        needArrange () {

            return this.arrangePlansParams.some(( item ) => {

                return item.length > 1;

            });

        },
        arrangePlansMap () {

            let paramsArr = [];

            for ( const deviceHistory of this.arrangePlansParams[0] ) {

                for ( const deviceQuantity of this.arrangePlansParams[1] ) {

                    for ( const deviceStorage of this.arrangePlansParams[2] ) {

                        paramsArr.push( [ deviceHistory, deviceQuantity, deviceStorage ] );

                    }

                }

            }

            let planMap = new Map();

            for ( const item of paramsArr ) {

                planMap.set( item, [] );

            }

            this.plan.products.forEach(( product ) => {

                let currentParam = [
                    product.metadata['cloud_storage.video_lifetime'],
                    product.metadata['cloud_storage.max_device_quantity'],
                    Number( product.metadata[ 'cloud_storage.space_capacity' ] / ( 1024 * 1024 * 1024 ).toFixed( 2 ))
                ];
                let planParam = paramsArr.find(( paramArr ) => {

                    return JSON.stringify( paramArr ) === JSON.stringify( currentParam );

                });

                planMap.get( planParam ).push( product );

            });

            let cycleObj = {
                'day': 1,
                'week': 7,
                'month': 30,
                'year': 360
            };

            planMap.forEach(( value, key ) => {

                if ( value.length === 0 ) {

                    planMap.delete( key );

                } else if ( value.length > 1 ) {

                    value.sort(( a, b ) => {

                        let aWeight = cycleObj[ a.cycle.standard.interval.unit ] * a.cycle.standard.interval.frequency;

                        let bWeight = cycleObj[ b.cycle.standard.interval.unit ] * b.cycle.standard.interval.frequency;

                        return aWeight - bWeight;

                    });

                }

                key[2] = key[2].toFixed( 2 );

            });

            return [...planMap];

        },
        limitedDay () {

            let limitedDay = this.eplan[ 'metadata' ][ 'virtual_product.effect_ttl' ];
            if ( !limitedDay ) {

                return {};

            }
            let date = timeResolvePDT( limitedDay );
            return {

                year: date.year,
                monthAbbr: date.monthAbbr,
                monthlong: date.monthLong,
                dateOfMonthOrder: date.dateOfMonthOrder,
                dateOfMonth: date.dateOfMonth

            };

        },

        switchs () {

            return this.active ? '-' : '+';

        },

        selected () {

            let ids = this.plan.products.map(({ id }) => id );
            return ids.includes( this.selectedId );

        },

        singleProduct () {

            return this.plan.products.length === 1;

        },

        price () {

            let eplan = this.eplan;
            let currency = this.$t( `CURRENCY.${eplan.currency}` );
            if ( this.plan.products.length === 1 ) {

                if ( Number( eplan.cycle.standard.salePrice ) === 0 ) {

                    return this.$t( 'plan.free' );

                }
                return `${currency} ${eplan.cycle.standard.salePrice}`;

            }
            let lowest = eplan.cycle.standard.salePrice;
            let highest = eplan.cycle.standard.salePrice;
            for ( let product of this.plan.products ) {

                let price = product.cycle.standard.salePrice;
                if ( price < lowest ) {

                    lowest = price;

                } else if ( price > highest ) {

                    highest = price;

                }

            }
            return `${currency} ${lowest} - ${currency} ${highest}`;

        },
        seriesDisabled () {

            let dis = true;
            let products = this.plan.products;
            for ( let product of products ) {

                if ( !this.itemDisabled( product )) {

                    dis = false;
                    break;

                }

            }
            return dis;

        }

    },

    watch: {

        selectedId ( selectedId ) {

            this.mySelectedId = selectedId;

        },

        active ( active ) {

            $( this.$refs.series ).slideToggle( 500 );
            if ( this.active ) {

                this.$emit( 'changeActive', this.index );

            }

        },

        activeItem ( activeItem ) {

            if ( activeItem !== this.index ) {

                this.active = false;

            }

        }

    }

};
</script>

<style lang="less">
    @media @mobile{
        .plan-item.single-product .radio-wrap{
            display: flex;
            flex-wrap: nowrap;
            align-items: flex-start;
        }
        .plan-item .radio-label{
            line-height: unset !important;
        }
    }
</style>

<style lang="less" scoped>
    .plan-item{
        padding: 0.4rem 0.3rem;
        border-radius: 0.1rem;
        box-shadow: 0 0 6px 2px rgba(0,0,0,.14);
        margin-bottom: 0.2rem;
        position: relative;
        height: auto;
        border: 1px solid #fff;
        @media @mobile {
            padding: 0.6rem 0.4rem 0.6rem;
            margin-bottom: 0.2rem;
        }
    }

    .product-pre-price-wrap{
        display: none;
        @media @mobile{
            display: inline;
        }
    }
    .plan-name-checked{
        margin-right: 0.1rem;
    }
    .plan-item.active{
        border: 1px solid @theme;
    }
    .plan-name{
        margin-bottom: 0.15rem;
        cursor: pointer;
        @media @mobile {
            margin-bottom: .2rem;
        }
    }
    .plan-name-text{
        font-size: 0.2rem;
        color: #333;
        font-weight: 500;
        display: inline-block;
        vertical-align: middle;
        .title-price{
            display: inline-block;
            margin-left: 0.1rem;
        }
    }
    .price-box{
        display: inline-block;
    }
    .price-box .pre-price{
        color: #777;
        text-decoration: line-through;
    }
    @media @pc{
        .plan-item.single-product .pre-price{
            font-size: 16px;
        }
    }
    @media @mobile {
        .plan-name-text{
            font-size: 0.3rem;
        }
    }
    .plan-series{
        padding-left: 0.4rem;
        margin-top: 0.4rem;
        &.no-active{
            display: none;
        }
        .series-item{
            padding: 0.2rem 0;
            border-top: 1px solid #ddd;
            margin: 0;
            cursor: pointer;
            font-size: 0;
            @media @pc{
                .pre-price{
                    font-size: 16px;
                }
            }
            .plan-details {
                display: inline-block;
                @media @mobile {
                    width: calc(100% - .36rem);
                    vertical-align: top;
                }
            }
            .plan-description {
                display: block;
                margin-top: 9px;
                margin-left: 35px;
                font-size: .16rem;
                font-weight: 500;
                color: #E74330;
                line-height: 1.2;
                &:empty {
                    display: none;
                }
                @media @mobile {
                    margin-left: .48rem;
                    font-size: .24rem;
                    margin-top: .14rem;
                }
            }
        }
        .device-quantity-box {
            padding: 0.2rem 0;
            border-top: 1px solid #ddd;
            margin: 0;
            &:last-child {
                padding-bottom: 0;
            }
            .device-quantity-title {
                font-weight: 500;
                font-size: 0.16rem;
                color: #555;
                @media @mobile{
                    font-size: 0.26rem;
                }
            }
            .series-item {
                border-top: none;
                padding: 0.16rem 0 0 0;
            }
        }
        .series-item>span>span{
            vertical-align: middle;
            display: inline-block;
            margin-left: 0.1rem;
            font-weight: 500;
            font-size: 0.18rem;
            @media @mobile{
                font-size: 0.26rem;
            }
        }
        .series-item.plan-disabled>span{
            color: #bbb !important;
        }
        @media @mobile {
            margin-top: 0.6rem;
            .series-item{
                padding: 0.4rem 0;
            }
            .series-item>span{
                font-size: 0.26rem;
            }
            .device-quantity-box {
                padding: 0.4rem 0;
                .series-item {
                    padding: 0.24rem 0 0 0;
                }
            }
        }
        .series-item:last-child {
            padding-bottom: 0;
        }
    }
    .price{
        color: #DD4429;
    }
    .plan-item .price-box{
        margin-left: 0.1rem;
        &>span{
            margin-left: 0;
        }
        &>span+span{
            margin-left: 0.1rem;
        }
    }
    .switchs{
        color: @theme;
        position: absolute;
        right: 0.3rem;
        top: 0.4rem;
        font-size: 0.4rem;
        line-height: 0.16rem;
        cursor: pointer;
        user-select: none;
        &.disabled{
            color: #bbb !important;
        }
    }
    @media @mobile {
        .switchs{
            top: 0.6rem;
        }
    }
    .switchs-cover{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        cursor: pointer;
    }
    .plan-item p{
        margin-bottom: 0;
        font-size: .16rem;
        margin-top: 0.15rem;
        @media @mobile {
            font-size: .26rem;
        }
    }
    .current-plan{
        display: inline-block;
        padding: 0 0.2rem;
        line-height: 0.3rem;
        background-color: #FFAC3E;
        color: #fff;
        border-radius: 0.08rem;
        font-weight: 500;
        @media @pc{
            &.mobile{
                display: none !important;
            }
        }
        @media @mobile{
            line-height: 1.5;
            &.pc,
            &.mobile{
                display: none !important;
            }
        }
    }
</style>

<style lang="less">
    .plan-item .checkbox-label{
        font-size: 0.2rem;
    }
    @media @mobile {
        .plan-item .checkbox-label,
        .plan-des{
            font-size: 0.3rem;
        }
        .plan-item{
            padding: 0.6rem 0.4rem;
            margin-bottom: 0.44rem;
        }
    }
    .plan-item .plan-disabled>.plan-name .plan-name-text,
    .plan-item .plan-disabled .price,
    .plan-item .plan-disabled .pre-price,
    .plan-item .plan-disabled .title-price,
    .plan-item .plan-disabled p{
        color: #bbb !important;
    }
</style>



// WEBPACK FOOTER //
// src/view/cloud/PlanItem.vue